import { useState, type ReactNode } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../lib/cart";

const fmt = (n: number) => n.toLocaleString("ko-KR");

export default function CartPopover({ children }: { children: ReactNode }) {
  const { items, subtotal, remove } = useCart();
  const [open, setOpen] = useState(false);

  return (
    <div className="cart-pop-root"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={(e) => { if (!e.currentTarget.contains(e.relatedTarget as Node)) setOpen(false); }}
    >
      {children}
      {open && (
        <div className="cart-pop-panel card" role="menu" aria-label="장바구니 미리보기">
          {items.length === 0 ? (
            <div style={{ padding: "var(--s-5)", textAlign: "center" }}>
              <p className="muted" style={{ fontSize: 13, marginBottom: 8 }}>장바구니가 비어있습니다.</p>
              <Link to="/catalog" className="btn btn-primary btn-sm">카탈로그 보기</Link>
            </div>
          ) : (
            <>
              <div style={{ padding: "10px 14px", borderBottom: "1px solid var(--border)", fontSize: 12, fontWeight: 600 }}>
                {items.length}개 품목
              </div>
              <div style={{ maxHeight: 280, overflowY: "auto" }}>
                {items.slice(0, 6).map((it) => (
                  <div key={it.product.id} style={{ padding: "10px 14px", borderBottom: "1px solid var(--border)", display: "flex", gap: 8, alignItems: "flex-start" }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 500, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{it.product.name}</div>
                      <div className="muted" style={{ fontSize: 11, marginTop: 2 }}>
                        {fmt(it.product.price)}원 × {it.quantity} = <strong>{fmt(it.product.price * it.quantity)}원</strong>
                      </div>
                    </div>
                    <button className="btn btn-ghost btn-sm" onClick={() => remove(it.product.id)} aria-label="삭제" style={{ padding: "2px 6px" }}>✕</button>
                  </div>
                ))}
                {items.length > 6 && (
                  <div className="muted" style={{ padding: "8px 14px", fontSize: 11, textAlign: "center" }}>외 {items.length - 6}개...</div>
                )}
              </div>
              <div style={{ padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <span className="muted" style={{ fontSize: 12 }}>합계</span>
                <span style={{ fontWeight: 700, color: "var(--primary)" }}>{fmt(subtotal)}원</span>
              </div>
              <div style={{ padding: "0 10px 10px", display: "flex", gap: 6 }}>
                <Link to="/cart" className="btn btn-outline btn-sm" style={{ flex: 1 }}>장바구니</Link>
                <Link to="/checkout" className="btn btn-cta btn-sm" style={{ flex: 1 }}>주문서 작성</Link>
              </div>
            </>
          )}
        </div>
      )}
      <style>{`
        .cart-pop-root { position: relative; }
        .cart-pop-panel {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          width: 320px;
          z-index: 60;
          box-shadow: var(--shadow-lg);
          animation: pop-in 140ms var(--ease-out);
        }
        @keyframes pop-in {
          from { opacity: 0; transform: translateY(-4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @media (max-width: 720px) {
          .cart-pop-panel { display: none; }
        }
      `}</style>
    </div>
  );
}
